module.exports = __webpack_public_path__ + "img/0024.e8023b67.jpg";